export default "__VITE_ASSET__3530d878__"